import { useEffect, useState } from "react";
import { DollarSign, CreditCard, Calendar, TrendingUp } from "lucide-react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebase";

export default function Math() {
  const [suscripciones, setSuscripciones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // bandera para evitar memory leak
    const user = auth.currentUser;
    if (!user) return;

    const q = query(
      collection(db, "suscripciones"),
      where("uid", "==", user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (isMounted) {
        const subs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setSuscripciones(subs);
        setLoading(false);
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  const gastoMensual = suscripciones.reduce((total, s) => total + Number(s.precio), 0);

  const proximoPagoInfo = suscripciones
    .slice()
    .sort((a, b) => new Date(a.proximoPago) - new Date(b.proximoPago))[0];

  const ahorroPotencial = gastoMensual * 0.15;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"></div>
        <style jsx>{`
          .loader {
            border-top-color: #3498db;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="p-4 sm:p-6 w-full max-w-6xl lg:max-w-7xl xl:max-w-[1200px] 2xl:max-w-[1400px] mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {/* Gasto Mensual */}
        <div className="flex-1 bg-blue-500 text-white rounded-xl p-6 shadow-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm opacity-80">Gasto Mensual</p>
              <p className="text-2xl font-bold">
                {suscripciones.length > 0 ? gastoMensual.toFixed(2) : "0.00"}€
              </p>
            </div>
            <DollarSign className="w-6 h-6 opacity-70" />
          </div>
          <p className="text-xs mt-2 opacity-70">
            {suscripciones.length > 0 ? (gastoMensual * 12).toFixed(2) : "0.00"}€ anuales
          </p>
        </div>

        {/* Suscripciones */}
        <div className="flex-1 bg-white rounded-xl p-6 shadow-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm opacity-80">Suscripciones</p>
              <p className="text-2xl font-bold">
                {suscripciones.length > 0 ? suscripciones.length : "0"}
              </p>
            </div>
            <CreditCard className="w-6 h-6 opacity-70" />
          </div>
          <p className="text-xs mt-2 text-gray-500">Servicios activos</p>
        </div>

        {/* Próximo Pago */}
        <div className="flex-1 bg-white rounded-xl p-6 shadow-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm opacity-80">Próximo Pago</p>
              <p className="text-2xl font-bold">
                {proximoPagoInfo ? Number(proximoPagoInfo.precio).toFixed(2) + "€" : "--"}
              </p>
            </div>
            <Calendar className="w-6 h-6 opacity-70" />
          </div>
          <p className="text-xs mt-2 text-yellow-600">
            {proximoPagoInfo
              ? `${new Date(proximoPagoInfo.proximoPago).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })} - ${proximoPagoInfo.nombre}`
              : "--"}
          </p>
        </div>

        {/* Ahorro Potencial */}
        <div className="flex-1 bg-green-500 text-white rounded-xl p-6 shadow-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm opacity-80">Ahorro Potencial</p>
              <p className="text-2xl font-bold">
                {suscripciones.length > 0 ? ahorroPotencial.toFixed(2) : "0.00"}€
              </p>
            </div>
            <TrendingUp className="w-6 h-6 opacity-70" />
          </div>
          <p className="text-xs mt-2 opacity-70">~15% optimizando suscripciones</p>
        </div>
      </div>
    </div>
  );
}
